export default __webpack_public_path__ + "static/media/626.a34240ec.jpg";